/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FattureProgettoDtoFromJSON, FattureProgettoDtoToJSON, } from './FattureProgettoDto';
/**
 * Check if a given object implements the AssociaFattureProgettoDtoList interface.
 */
export function instanceOfAssociaFattureProgettoDtoList(value) {
    return true;
}
export function AssociaFattureProgettoDtoListFromJSON(json) {
    return AssociaFattureProgettoDtoListFromJSONTyped(json, false);
}
export function AssociaFattureProgettoDtoListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fattureProgettoDtoList': json['fattureProgettoDtoList'] == null ? undefined : (json['fattureProgettoDtoList'].map(FattureProgettoDtoFromJSON)),
    };
}
export function AssociaFattureProgettoDtoListToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fattureProgettoDtoList': value['fattureProgettoDtoList'] == null ? undefined : (value['fattureProgettoDtoList'].map(FattureProgettoDtoToJSON)),
    };
}
